<template>
  <v-container fluid>
    <PageTitle>
      <div>
        Email Previews
      </div>
      <v-btn right
             href="https://help.mobilelocker.com/article/259-how-to-preview-an-email-template-before-sending-it"
             target="_blank"
             icon>
        <v-icon color="primary">
          fas fa-fw fa-question-circle
        </v-icon>
      </v-btn>

      <template v-if="teamStats"
                v-slot:buttons>
        <div class="mr-4">
          Remaining Email Previews: {{ teamStats.remaining_previews | number }} / {{ teamStats.total_previews | number }}
        </div>
        <v-btn :to="{name: 'admin.mailgun.email_preview.create'}"
               color="primary"
               :disabled="teamStats.has_remaining_previews === false">
          Create
        </v-btn>
      </template>
    </PageTitle>

    <v-card class="mb-4">
      <v-data-table :headers="headers"
                    :items="previews"
                    :items-per-page="50"
                    :footer-props="{'items-per-page-options': [10, 25, 50, 100, -1]}">

        <template v-slot:item.template.name="{item: preview}">
          <router-link :to="{name: 'admin.mailgun.email_preview.show', params: {previewID: preview.id}}">
            {{ preview.template?.name }}
          </router-link>
        </template>
        <template v-slot:item.created_at="{item: preview}">
          {{ preview.created_at | datetime }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<style>
pre {
  max-height: none;
}
</style>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import emailPreviewService from '../../services/emailPreviewService';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle},
  data() {
    return {
      previews: [],
    }
  },
  computed: {
    ...mapGetters([
      'emailPreviewsEnabled',
      'team',
      'user',
    ]),
    ...mapGetters('emailPreviews', [
      'teamStats',
    ]),
    headers() {
      return [
        {
          text: 'Email template',
          value: 'template.name',
        },
        {
          text: 'Tested clients',
          value: 'clients_count',
        },
        {
          text: 'User',
          value: 'user.name',
        },
        {
          text: 'Date',
          value: 'created_at',
          cellClass: 'text-nowrap',
        },
      ]
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch('emailPreviews/fetchTeamStats');

      emailPreviewService.getTests()
        .then(data => {
          this.previews = orderBy(data, ['id'], ['desc']);
        })
    },
    getResults(previewID) {
      emailPreviewService.getResults(previewID)
        .then(() => {
          this.fetchData();
        })
    }
  }
}
</script>
